import FxxlCore from '@fxxl/core';
export const fxxlLazyloadModule = async function () {

    /**
     * Lazyload
     *
     * module: karriereportal
     * presence: Karriereportal
     * event: firstActionCached
     * **************************************
     */
    FxxlCore.lazyloadModuleByView(
        'karriereportal',
        [{presence: 'karriereportal'}],
        FxxlCore.getConfig().eventNames.firstActionCached
    ).then(
        /**
         * @param {{FxxlKarriereFilter:function}} module
         */
        (module) => {
            if (module?.FxxlKarriereFilter !== undefined) {
                /**
                 * Karriereportal-Filter
                 */
                document.querySelectorAll('.fxxl-karriere-filter').forEach((element) => {
                    new module.FxxlKarriereFilter(element);
                });
            }
        }).catch(() => {});

    /**
     * Lazyload
     *
     * module: json_modal
     * presence: fxxl
     * viewType: artikel
     * viewName: detail
     * **************************************
     */
    FxxlCore.lazyloadModuleByView(
        'json_modal',
        [{view_type: 'artikel', view_name: 'detail'}]
    ).then(
        /**
         * @param {{setup:function}} module
         */
        (module) => {
            if (module?.setup !== undefined) {
                module?.setup();
            }
        }).catch(() => {});

    /**
     * Lazyload
     *
     * module: add_to_cart
     * presence: fxxl
     * viewType: artikel
     * viewName: detail
     * **************************************
     */
    FxxlCore.lazyloadModuleByView(
        'add_to_cart',
        [{view_type: 'artikel', view_name: 'detail'}]
    ).then(
        /**
         * @param {{setup:function}} module
         */
        (module) => {
            if (module?.setup !== undefined) {
                module?.setup();
            }
        }).catch(() => {});


    /**
     * Lazyload
     *
     * module: velomatrix
     * viewType: artikel
     * viewName: detail
     * **************************************
     */
    FxxlCore.lazyloadModuleByView(
        'velomatrix',
        [{view_type: 'artikel', view_name: 'detail'}]
    ).then(
        /**
         * @param {{setup:function}} module
         */
        (module) => {
            if (module?.setup !== undefined) {
                module?.setup();
            }
        }).catch(() => {});

    /**
     * Lazyload
     *
     * module: branch_list
     * viewType: branch
     * viewName: change
     * **************************************
     */
    FxxlCore.lazyloadModuleByView(
        'branch_list',
        [
            {view_type: 'branch', view_name: 'change'},
            // Or
            {view_type: 'branch', view_name: 'servicepartner'}
        ]
    ).then(
        /**
         * @param {{setup:function}} module
         */
        (module) => {
            if (module?.setup !== undefined) {
                module?.setup();
            }
        }).catch(() => {});


    /**
     * Lazyload
     *
     * module: branch_search
     * viewType: branch
     * viewName: change
     * event: firstAction
     * **************************************
     */
    FxxlCore.lazyloadModuleByView(
        'branch_search',
        [
            {view_type: 'branch', view_name: 'change'},
            // Or
            {view_type: 'branch', view_name: 'servicepartner'},
            // Or
            {view_type: 'warengruppe'}
        ],
        FxxlCore.getConfig().eventNames.firstAction
    ).then(
        /**
         * @param {{setup:function}} module
         */
        (module) => {
            if (module?.setup !== undefined) {
                /**
                 * Branch-Search
                 */
                module?.setup();
            }
        }).catch(() => {});

    /**
     * Lazyload
     *
     * module: narrower
     * viewType: warengruppe OR suche
     * viewName: detail
     * event: firstActionCached
     * **************************************
     */
    FxxlCore.lazyloadModuleByView(
        'narrower',
        [
            {view_type: 'warengruppe', view_name: 'detail'},
            // OR
            {view_type: 'praesenz', view_name: 'search'},

        ],
        FxxlCore.getConfig().eventNames.firstActionCached
    ).then(
        /**
         * @param {{setup:function}} module
         */
        (module) => {
            if (module?.NarrowerDisplayController !== undefined) {
                /**
                 * Initialize Narrowers
                 */
                new module.NarrowerDisplayController();
            }
        }).catch(() => {});

    /**
     * Lazyload
     *
     * module: fxxl_campaign_banners
     * viewType: warengruppe OR suche
     * viewName: detail
     * event: firstActionCached
     * **************************************
     */
    FxxlCore.lazyloadModuleByView(
        'fxxl_campaign_banners',
        [
            {view_type: 'warengruppe', view_name: 'detail'},
            // OR
            {view_type: 'praesenz', view_name: 'search'}
        ],
        FxxlCore.getConfig().eventNames.firstActionCached
    ).then(
        /**
         * @param {{setup:function}} module
         */
        (module) => {
            if (module?.setup !== undefined) {
                /**
                 * Kampagnen-Banner
                 */
                module.setup();
            }
        }).catch(() => {});

    /**
     * Lazyload
     *
     * module: narrower
     * viewType: warenkorb
     * viewName: checkout2
     * **************************************
     */
    FxxlCore.lazyloadModuleByView(
        'warenkorb_checkout2',
        [
            {view_type: 'warenkorb', view_name: 'checkout2'}
        ]
    ).then(
        /**
         * @param {{setup:function}} module
         */
        (module) => {
            if (module?.FxxlWarenkorbCheckout2 !== undefined) {
                /**
                 * Initialize checkout2
                 */
                new module.FxxlWarenkorbCheckout2();
            }
        }).catch(() => {});

    /**
     * Lazyload
     *
     * module: leasingautomation
     * viewType: warenkorb
     * viewName: checkout4
     * **************************************
     */
    FxxlCore.lazyloadModuleByView(
        'leasingautomation',
        [
            {view_type: 'warenkorb', view_name: 'checkout4'}

        ]
    ).then(
        /**
         * @param {{setup:function}} module
         */
        (module) => {
            if (module?.setup !== undefined) {
                /**
                 * Initialize leasingautomation
                 */
                new module.setup();
            }
        }).catch(() => {});



    /**
     * Lazyload
     *
     * module: warenkorb_vorschau
     * event: firstActionCached
     * **************************************
     */
    FxxlCore.lazyloadModuleByView(
        'warenkorb_vorschau',
        [{}],
        FxxlCore.getConfig().eventNames.firstActionCached
    ).then(
        /**
         * @param {{setup:function}} module
         */
        (module) => {
            if (module?.setup !== undefined) {
                new module.setup();
            }
        }).catch(() => {});

    /**
     * Lazyload
     *
     * module: checkout4_leasing
     * viewType: warenkorb
     * viewName: checkout4
     * **************************************
     */
    FxxlCore.lazyloadModuleByView(
        'checkout4_leasing',
        [
            {view_type: 'warenkorb', view_name: 'checkout4'}

        ]
    ).then(
        /**
         * @param {{setup:function}} module
         */
        (module) => {
            if (module?.setup !== undefined) {
                /**
                 * Initialize leasingautomation
                 */
                new module.setup();
            }
        }).catch(() => {});

    /**
     * Lazyload
     *
     * module: melibo
     * event: firstActionCached
     * **************************************
     */
    FxxlCore.lazyloadModuleByView(
        'melibo',
        [{}],
        FxxlCore.getConfig().eventNames.firstActionCached
    ).then(
        /**
         * @param {{FxxlMelibo:function}} module
         */
        (module) => {
            if (module?.FxxlMelibo !== undefined) {
                new module.FxxlMelibo();
            }
        }).catch(() => {});

    /**
     * Lazyload
     *
     * script: general
     * **************************************
     */
    FxxlCore.lazyloadModuleByView(
        'general',
        [{}],
        FxxlCore.getConfig().eventNames.firstActionCached,
        'script'
    ).then(() => {}).catch(() => {});


    /**
     * Lazyload
     *
     * script: checkout
     * viewType: warenkorb
     * **************************************
     */
    FxxlCore.lazyloadModuleByView(
        'checkout',
        [{view_type: 'warenkorb'}],
        null,
        'script'
    ).then(() => {}).catch(() => {});


    /**
     * Lazyload
     *
     * script: artikel
     * viewType: artikel | merkliste
     * **************************************
     */
    FxxlCore.lazyloadModuleByView(
        'artikel',
        [
            {view_type: 'artikel'},
            // OR
            {view_type: 'merkliste'}
        ],
        FxxlCore.getConfig().eventNames.firstActionCached,
        'script'
    ).then(() => {}).catch(() => {});


    /**
     * Lazyload
     *
     * script: warengruppe
     * viewType: warengruppe | praesenz
     * **************************************
     */
    FxxlCore.lazyloadModuleByView(
        'warengruppe',
        [
            {view_type: 'warengruppe'},
            // OR
            {view_type: 'praesenz'}
        ],
        FxxlCore.getConfig().eventNames.firstActionCached,
        'script'
    ).then(() => {}).catch(() => {});


    /**
     * Lazyload
     *
     * script: person
     * viewType: person
     * **************************************
     */
    FxxlCore.lazyloadModuleByView(
        'person',
        [
            {view_type: 'person'},
            {view_type: 'warenkorb', view_name: 'checkout2'}
        ],
        null,
        'script'
    ).then(() => {}).catch(() => {});

    /**
     * Lazyload
     *
     * module: FxxlPayPalWidgetPaylater
     * event: firstActionCached
     * **************************************
     */
    FxxlCore.lazyloadModuleByView(
        'fxxl_paypal',
        [{}],
        FxxlCore.getConfig().eventNames.firstActionCached
    ).then(
        /**
         * @param {{FxxlPayPalWidgetPaylater.init:function}} module
         */
        (module) => {
            if (module?.FxxlPayPalWidgetPaylater !== undefined) {
                module.FxxlPayPalWidgetPaylater.init();
            }
        }).catch(() => {});
};
